module.exports = "/_next/static/images/OgAcademy-dd004474a57c04b98846f11d2350186e.png";